// Значок отзывов Google (27.10.2026): «★ 5,0 · 24 rəy Google-da». Рейтинг и
// число отзывов — здесь, руками, одной строкой: из Google API ничего не тянем.
// Обновлять по профилю: https://www.google.com/maps?cid=12111394556129007192
//
// cid проверен в браузере 27.10.2026: открывает «Yolutap», 5.0 (24) —
// 23 отзыва на 5★ и 1 на 4★. cid 10725797170940698802 из задачи открывал
// пустую карточку места.

export const GOOGLE_REVIEWS = { rating: 5.0, count: 24, url: "https://www.google.com/maps?cid=12111394556129007192" } as const;

type Lang = "az" | "ru" | "en";

/** 1 отзыв, 2–4 отзыва, 5–20 отзывов, 21 отзыв, 22 отзыва… */
export function ruReviews(n: number): string {
  const d = n % 10;
  const dd = n % 100;
  if (d === 1 && dd !== 11) return "отзыв";
  if (d >= 2 && d <= 4 && (dd < 12 || dd > 14)) return "отзыва";
  return "отзывов";
}

/** Рейтинг с одной цифрой после запятой: AZ и RU — запятая, EN — точка. */
export const formatRating = (r: number, lang: Lang) => (lang === "en" ? r.toFixed(1) : r.toFixed(1).replace(".", ","));

/** Текст значка без звезды: «5,0 · 24 rəy Google-da». */
export function reviewsBadgeText(lang: Lang, g: { rating: number; count: number } = GOOGLE_REVIEWS): string {
  const r = formatRating(g.rating, lang);
  if (lang === "ru") return `${r} · ${g.count} ${ruReviews(g.count)} в Google`;
  if (lang === "en") return `${r} · ${g.count} Google ${g.count === 1 ? "review" : "reviews"}`;
  return `${r} · ${g.count} rəy Google-da`;
}

/** Подсказка для читалки экрана: что откроется и где. */
export const REVIEWS_BADGE_LABEL: Record<Lang, string> = {
  az: "Google-da rəylər — yeni pəncərədə açılır",
  ru: "Отзывы в Google — откроются в новой вкладке",
  en: "Google reviews — opens in a new tab",
};
